const regex = /[\W\\]/g

export default (str = '') => str.replace(regex, '')
